import { browsePlacesTitle, roomFinderTitle } from './RoomPanelHeader.locstring.json';
import { IconButton } from '@fluentui/react/lib/Button';
import { Label } from '@fluentui/react/lib/Label';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { closeText } from 'owa-locstrings/lib/strings/closetext.locstring.json';
import * as React from 'react';
import { useClientStyles } from 'owa-react-hooks/lib/useClientStyles';
import { useModeStyles } from 'owa-react-hooks/lib/useModeStyles';

const styles = {
    base: require('./RoomPanelHeader.scss'),
    mac: require('./RoomPanelHeader.macoutlook.scss'),
};

export interface RoomPanelHeaderProps {
    onRoomPanelClose: () => void;
}

export default function RoomPanelHeader(props: RoomPanelHeaderProps) {
    const { getClass } = useClientStyles(styles);
    const { getModeAwareClass } = useModeStyles(getClass);
    return (
        <div className={getClass('container')}>
            <Label className={getClass('label')}>
                {isFeatureEnabled('cal-mf-advancedRoomBookingV2')
                    ? loc(roomFinderTitle)
                    : loc(browsePlacesTitle)}
            </Label>
            <IconButton
                ariaLabel={loc(closeText)}
                iconProps={{ iconName: ControlIcons.Cancel }}
                onClick={props.onRoomPanelClose}
                styles={{
                    flexContainer: getClass('closeButtonFlexContainer'),
                    icon: getClass('closeButtonIcon'),
                    root: getModeAwareClass('closeButtonRoot'),
                }}
            />
        </div>
    );
}
